import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { graphql, useStaticQuery } from "gatsby"
import findImage from "@/utils/find-image"
import SupportArticleAssetWrapper from "@/components/SupportArticleAssetWrapper"

const SupportImage = ({ src, alt, className = "" }) => {
  const data = useStaticQuery(graphql`
    query {
      allFile(
        filter: {
          sourceInstanceName: { eq: "images" }
          relativeDirectory: { eq: "support" }
        }
      ) {
        edges {
          node {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  `)
  // TODO: Does this need to be in a MediaWrapper component? (browse through a bunch of support docs in prod to see if that is the case)
  return (
    <SupportArticleAssetWrapper>
      <GatsbyImage
        className={className}
        image={getImage(findImage(data.allFile, src))}
        alt={alt}
      />
    </SupportArticleAssetWrapper>
  )
}

export default SupportImage
